import React, { Component } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

export default class VideoJS extends Component {
  componentDidMount() {
    this.player = videojs(this.videoNode, this.props)
    this.player.on('ended', this.props.onEnded)
    this.player.textTracks().on('change', this.props.textChanged)
    var volumePanel = document.getElementsByClassName('vjs-volume-panel')[0]
    var controlBar = document.getElementsByClassName('vjs-control-bar')[0]
    controlBar.appendChild(volumePanel)
  }

  componentWillUnmount() {
    if (this.player) setTimeout(() => this.player.dispose(), 1000)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.sources[0].src !== nextProps.sources[0].src) {
      this.player.src(nextProps.sources)
      let tracks = this.player.textTracks()
      if (tracks[0] && tracks[0].src){
        tracks.removeTrack(tracks[0]);
      } 
      if (nextProps.tracks[0] && nextProps.tracks[0].src) {
        tracks.addTrack(new videojs.TextTrack({
          crossorigin: 'anonymous',
          src: nextProps.tracks[0].src,
          kind: 'captions',
          srclang: 'en',
          label: 'English',
          mode: 'disabled',
          tech: this.player.tech_,
          default: nextProps.captionOn
        }))
      }
    }
  }

  render() {
    return (
      <div data-vjs-player>
        <video 
          className="video-js"
          crossOrigin="anonymous"
          ref={node => this.videoNode = node}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/VideoJS.js